<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <PackagesSidebar ref="sidebar" />

    <div class="flex justify-between">
      <p>Packages are collections of stock products that can be offered in combination with sales products</p>
      <div class="flex justify-end">
        <vs-button icon="add" @click="onClickCreateNew" type="relief" color="primary" class="mr-3">Add new</vs-button>
      </div>
    </div>

    <!-- table -->
    <div class="data-list-list-view">
      <vs-table ref="table" class="mt-4" pagination search :max-items="10" :data="filteredPackages" @selected="onClicked">
        <template slot="thead">
          <vs-th sort-key="name">Package name</vs-th>
          <vs-th>Products</vs-th>
          <vs-th sort-key="createdAt">Created at</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div class="product-name font-medium truncate flex flex-row items-center">
                  <div class="flex justify-start">
                    <img width="40" :src="ProductIcon" />
                    <div class="ml-4">
                      <div v-if="tr.name">
                        {{ tr.name }}
                      </div>
                      <div v-else>
                        <vs-chip> No name </vs-chip>
                      </div>
                      <small>{{ tr.id }}</small>
                    </div>
                  </div>
                </div>
              </vs-td>
              <vs-td>
                {{ tr.stockIngredients.length }}
                products
              </vs-td>
              <vs-td>
                <div v-if="tr.createdAt" class="flex">
                  <feather-icon class="mr-1" :icon="'CalendarIcon'" svgClasses="text-grey w-5 h-5" />
                  {{ tr.createdAt | formatDate }}
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/product-icon.png";
import PackagesSidebar from "./PackagesSidebar.vue";

export default {
  components: {
    PackagesSidebar
  },
  data() {
    return {
      isLoading: true,
      ProductIcon
    };
  },
  methods: {
    onClicked(item) {
      this.$refs.sidebar.show(item.id);
    },
    async onClickCreateNew() {
      this.$refs.sidebar.showEmptyPackage();
    }
  },
  computed: {
    ...mapGetters({
      countries: "pos/countries/countries",
      packages: "pos/packages/packages"
    }),

    filteredPackages() {
      return this.packages.slice().sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
    }
  },

  async created() {
    this.isLoading = true;
    await Promise.all([this.$store.dispatch("pos/packages/getPackages"), this.$store.dispatch("pos/countrySettings/getCountrySettings")]);
    this.isLoading = false;
  }
};
</script>